import React, { useEffect, useState } from 'react';
import axios from 'axios';

const NotificationSound = () => {
  const [orders, setOrders] = useState([]);

  // Request notification permission on mount.
  useEffect(() => {
    if ("Notification" in window && Notification.permission !== "granted") {
      Notification.requestPermission();
    }

    const intervalId = setInterval(() => {
      checkForNewOrders();
    }, 30000); // Poll every 10 seconds

    return () => clearInterval(intervalId);
  }, []);

  const checkForNewOrders = async () => {
    try {
      const response = await axios.get(
        'https://kirupam.shop/admin/admin_api/check_new_orders.php'
      );
      const newOrders = response.data.newOrders;

      if (Array.isArray(newOrders) && newOrders.length > 0) {
        console.log('New orders detected:', newOrders);
        setOrders(prev => [...prev, ...newOrders]);
        playNotificationSound();
        newOrders.forEach(order => showPushNotification(order));
      }
    } catch (error) {
      console.error('Error checking for new orders:', error);
    }
  };

  const playNotificationSound = () => {
    const audio = new Audio('/success.mp3');
    audio.play().catch(error => console.error('Error playing notification sound:', error));
  };

  const showPushNotification = (order) => {
    const title = 'New Order Received!';
    const options = {
      body: `Order ID: ${order.id}\nTotal: $${order.totalCharge}`,
      vibrate: [200, 100, 200],
    };

    if ("Notification" in window && Notification.permission === "granted") {
      new Notification(title, options);
    } else {
      console.warn('Browser notifications are not permitted.');
    }
  };

  return null;
};

export default NotificationSound;
